import React ,{useState}from "react";
import { useSelector } from "react-redux";
//import { updateUserData } from "../../../store/actions/User";
import "./ClassUI.css";
import { useDispatch } from "react-redux";
import {Link, useRouteMatch,Switch, Route } from "react-router-dom";
import Loading from "../../Loading/Loading";

const ClassUI=()=>{


   
    const localToken= localStorage.getItem("profile");
    const token = useSelector((state)=>state?.user?.user?.token);
   
   
    const [loader , setLoader] =useState({status:false});
  // const {category} = useParams();
  const {url,path} =useRouteMatch();
  const dispatch = useDispatch();
    return <>
    {(token===localToken&&token&&localToken)?
<>
<div className=" ">

        {<Loading Load={loader?.status}/>}
        <div  className="class-ui-backdrop">
            </div></div>
</> :<>

    
    
    </>
}
</>
}
export default ClassUI